<script lang="ts" setup>
import { AssetSource } from '@commercetools/platform-sdk';

import brokenPeanut from '@/assets/broken-peanut.png';
import SmallBodyText from '@/components/base/typography/SmallBodyText.vue';
import { AssetData, CategoryData } from '@/graphql/categoryQuery';

defineProps<{ suggestedCategories: CategoryData[] }>();

const findImage = (category: CategoryData) => {
  const inList = category?.assets?.find((asset: AssetData) => asset?.tags?.includes('in list'));
  const asset = inList ?? category?.assets?.[0];
  const imgDefault = asset?.sources.find((source: AssetSource) => source.dimensions?.w === 228);
  return imgDefault?.uri ?? asset?.sources[0]?.uri ?? brokenPeanut;
};
</script>

<template>
  <div class="grid grid-cols-4 mt-4 sm:flex gap-x-8 gap-y-4">
    <div
      v-for="category in suggestedCategories"
      :key="category.key"
      class="inline-flex items-center w-16 flex-column justify-content-start sm:w-24"
    >
      <RouterLink
        class="flex items-center justify-center w-16 h-16 font-semibold leading-none bg-white border border-solid rounded-full focus:no-underline hover:no-underline color-inherit sm:w-24 sm:h-24 border-nuts-neutral-200"
        data-promo="1"
        data-promo-name="Merchandising"
        :data-promo-creative="`Shop By Category: ${category.name}`"
        :to="`${category.path}`"
      >
        <img
          :alt="`Link to ${category.name}`"
          :src="findImage(category)"
          class="object-contain w-11/12 rounded-full h-11/12"
        />
      </RouterLink>
      <SmallBodyText class="mt-2 font-semibold text-center">{{ category.name }}</SmallBodyText>
    </div>
  </div>
</template>
